export default {
    acquiring_device: "Acquiring device",
    add_expense: "Add expense",
    add_income: "Add income",
    advance_noun: "Advance",
    all_pay_methods: "All payment methods",
    bank_terminal: "Bank terminal",
    cash_operation: "Cash operation",
    cashdesk: "Cashdesk",
    cashier: "Cashier",
    cashier_inn: "Cashier INN",
    cashier_name: "Cashier name",
    cashless_payment: "Cashless payment",
    cashless_payments: "Cashless payments",
    cheque: "Cheque",
    cheque_generation_in_process_status_might_change_later: "Cheque generation in process. It may take some time for status to change.",
    cheques: "Cheques",
    close_shift: "Close shift",
    closing_balance: "Closing balance",
    create_cheque: "Create fiscal cheque",
    dashboard: "Dashboard",
    data_is_invalid: "Data is invalid",
    data_is_valid: "Data is valid",
    deposit_to_cashdesk: "Deposit to cashdesk",
    enter_amount: "Enter amount",
    enter_the_cheque_number: "Enter the cheque number",
    error_printing_cheque: "Error printing cheque",
    fiscal_cheque_copy_print: "Fiscal Cheque Copy Print",
    fiscal_cheque_print: "Fiscal cheque print",
    fiscal_device: "Fiscal device",
    fiscal_registrar: "Fiscal registrar",
    fiscal_registrar_management: "Fiscal registrar management",
    fixed: "Fixed",
    injection: "Injection",
    issue_an_advance: "Issue an advance",
    kkm_url: "HTTP address of the trading equipment server. Fill in if the cash register server is not connected locally.",
    market_as_fiscal_cheque_manually: "Mark as fiscal cheque manually",
    name_of_service_in_cheque: "Name of service in cheque",
    not_subject_to_vat: "Not subject to VAT",
    only_for_payment_through_terminal: "Only for payment through terminal",
    open_shift: "Open shift",
    opened_at: "Opening date",
    opening_balance: "Opening balance",
    partial_prepayment: "Partial prepayment",
    print_totals: "Print totals",
    process_advances_as: "Process advance payments as",
    sale_of_goods: "Sale of goods",
    sales: "Sales",
    send_services_in_cheque: "Send services in cheque",
    shift: "Shift",
    shift_number: "Shift number",
    shifts: "Shifts",
    system_to_use: "System to use",
    terminal: "Terminal",
    totals: "Totals",
    vat_rate: "VAT rate",
    waiting_for_payment_in_terminal: "Waiting for payment at the terminal",
    who_accepts_payment: "Who accepts payment",
    withdraw_from_cashdesk: "Withdraw from cashdesk",
    withdrawal: "Withdrawal",
    withdrawal_replenishment_from_the_cash_register: "Withdrawal / replenishment from the cash register",
    withdrawal_replenishment_of_cash: "Withdrawal/replenishment of cash",
    xreport: "X-report",
    xreports: "X-reports"
}
